import axios from "axios";
import { BASE_URL_BETA } from "../../constant/api";
import { OrgTypeFilter, PaginationFilter } from "./interface";

export class PharmacyService {
   static getPharmacyList(filter: PaginationFilter & OrgTypeFilter) {
      return axios.get(`${BASE_URL_BETA}/admin/company`, { params: filter });
   }
}
